@for (tokenLimitation of limitations; track tokenLimitation.name; let i = $index, isLast = $last) {
    <div class="reward-token-card__limitation">
        <span class="reward-token-card__limitation-name">{{ tokenLimitation.name }}:&nbsp;</span>
        <span class="reward-token-card__limitation-value">{{ tokenLimitation.value }}</span>
        <span>
            @if (!isEpcotEnabled) {
                &nbsp;
            }
            @if (!isLast && (isEpcotEnabled || isRewardDrawerEnabled)) {
                <span class="reward-token-card__separator reward-token-card_separator-new-reward-drawer"></span>
            }
            @if (!isLast && !isEpcotEnabled && !isRewardDrawerEnabled) {
                <span class="reward-token-card__separator">|&nbsp;&nbsp;</span>
            }
        </span>
    </div>
}
